import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import api from '../../../services/api';
import ClientDetail from './ClientDetail';
import { Client } from '../../../types';

const ClientDetailWrapper: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { token } = useAuth();
  const [client, setClient] = useState<Client | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchClient = async () => {
      if (!id) return;

      try {
        setLoading(true);
        const response = await api.get<Client>(`/api/clients/${id}`, token || undefined);
        setClient(response);
      } catch (err) {
        console.error('Failed to fetch client:', err);
        setError('Failed to load client');
      } finally {
        setLoading(false);
      }
    };

    fetchClient();
  }, [id, token]);

  const handleBack = () => {
    navigate('/clients');
  };

  const handleSelectProject = (projectId: number) => {
    navigate(`/projects/${projectId}`);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading client...</p>
        </div>
      </div>
    );
  }

  if (error || !client) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <p className="text-red-600">{error || 'Client not found'}</p>
          <button
            onClick={handleBack}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Back to Clients
          </button>
        </div>
      </div>
    );
  }

  return (
    <ClientDetail
      client={client}
      onBack={handleBack}
      onSelectProject={(project) => handleSelectProject(project.id)}
    />
  );
};

export default ClientDetailWrapper;
